import React, { useMemo } from 'react';
import { Tag } from '../../../../design-system';
import { BodyButton } from './bodyStyle.style';
import { BodyTypeFilterResultCounts, FilterOption } from '../../../types';
import { FilterTypes } from '../../../constants/initialFilters';
import CheckMarkIcon from '../../../assets/icons/CheckMarkIcon';

type BodyType = keyof BodyTypeFilterResultCounts;

interface BodyProps {
  body: BodyType;
  filterType: string;
  bodyTypeOptions: { [key: string]: FilterOption };
  confirmedFilters: FilterTypes;
  availableFilters: string[];
  handleAddFilter: (filterType: string, value: string, isChecked?: boolean) => void;
}

const Body: React.FC<BodyProps> = ({
  body,
  filterType,
  bodyTypeOptions,
  confirmedFilters,
  handleAddFilter,
  availableFilters,
}) => {
  const isAlpha = !process.env.IS_LEGACY;
  const { value, label } = bodyTypeOptions[body] as { value: string; label: string };
  const isSelected = confirmedFilters.bodyType.includes(value);
  const isAvailable = useMemo(() => !!availableFilters.includes(body), [availableFilters, body]);

  if (isAlpha) {
    return (
      <Tag
        variant="selectable"
        label={label}
        checked={isSelected}
        disabled={!isAvailable}
        value={value}
        size="md"
        onChange={() => handleAddFilter(filterType, value, isSelected)}
        data-testid={`bodyStyle-${value}`}
        data-cy="bodyStyle-button"
        data-isdisabled={!isAvailable}
      />
    );
  }

  return (
    <BodyButton
      type="button"
      disabled={!isAvailable}
      onClick={() => handleAddFilter(filterType, value, isSelected)}
      data-testid={`bodyStyle-${value}`}
      isSelected={isSelected}
      isAvailable={isAvailable}
    >
      {isSelected && <CheckMarkIcon size={24} />}
      {label}
    </BodyButton>
  );
};

export default Body;
